import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useUserData } from '@/hooks/useUserData';
import LoadingScreen from '@/components/common/LoadingScreen';
import { toast } from 'react-hot-toast';

interface ReportGuardProps {
  children: React.ReactNode;
}

export default function ReportGuard({ children }: ReportGuardProps) {
  const { currentUser } = useAuth();
  const { userData, loading, error } = useUserData();
  const location = useLocation();

  // Handle loading state
  if (loading) {
    return <LoadingScreen />;
  }

  // Handle authentication
  if (!currentUser) {
    toast.error('Please sign in to access the report');
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  // Handle error state
  if (error) {
    toast.error('Failed to verify report access');
    return <Navigate to="/dashboard" replace />;
  }

  // Check report availability
  if (!userData?.reportAvailable) {
    toast.error('Report is not available yet');
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}